export const MCP_SSO_REVOKE_CONFIRMATION = "REVOKE MCP SSO";
export const MCP_SSO_RESET_CONFIRMATION = "RESET MCP SSO";

export function canManageMcpSso(isAdmin) {
    return isAdmin === true;
}

export function canRetryMcpSso(access) {
    return (
        access?.status === "sync_error" &&
        access?.syncErrorCode !== "reset_cleanup_pending"
    );
}

export function canSaveMcpSsoLevel(level, confirmation) {
    return level !== "none" || confirmation === MCP_SSO_REVOKE_CONFIRMATION;
}

export function canSubmitMcpSsoReset(confirmation) {
    return confirmation === MCP_SSO_RESET_CONFIRMATION;
}

export function canConnectMcpSso(access) {
    return (
        access?.accessLevel !== "none" &&
        access?.syncErrorCode !== "reset_cleanup_pending" &&
        ["provisioning", "awaiting_link", "active", "sync_error"].includes(access?.status)
    );
}
